import { z } from "zod";
import { displayName } from "./api.js";
import { requestId } from "./room.js";
/** Why an admin did something: shown in Admin › Activity, never to the player. */
const reason = z.string().trim().min(2, "Write a short reason (2 to 140 characters).").max(140, "Keep the reason under 140 characters.");
/** An in-app path such as /tournaments/T-123 or /clubs/CL-ABC?tab=members; never another site. */
export const inAppPath = z.string().trim().max(200).regex(/^\/(?!\/)[\w\-./?=&%~]*$/, "The link must be a path inside DIGU that starts with /, such as /tournaments.");
export const AnnouncementAudience = z.enum(["all", "members", "active7d"]);
export const AnnouncementPost = z.object({
    title: z.string().trim().min(2, "Write a title of 2 to 60 characters.").max(60, "Keep the title under 60 characters."),
    body: z.string().trim().min(2, "Write a message of 2 to 280 characters.").max(280, "Keep the message under 280 characters."),
    audience: AnnouncementAudience,
    link: inAppPath.optional(),
    push: z.boolean(),
    requestId,
});
const clubName = z.string().trim().min(2, "A club name is 2 to 40 characters.").max(40, "A club name is 2 to 40 characters.");
export const AdminClubRename = z.object({ name: clubName, reason, requestId });
export const AdminClubMember = z.object({ publicId: z.string().trim().min(1).max(40), reason, requestId });
export const AdminClubDisband = z.object({ reason, requestId });
export const AdminPlayerRename = z.object({ name: displayName, reason, requestId });
export const AdminPlayerReason = z.object({ reason, requestId });
export const AdminPlayerSignOut = z.object({ requestId });
export const AdminGrantItem = z.object({ itemId: z.string().trim().min(2).max(40), days: z.number().int().min(1).max(365).optional(), reason, requestId });
export const AdminRevokeItem = z.object({ itemId: z.string().trim().min(2).max(40), reason, requestId });
export const AdminDeletePlayer = z.object({ confirmUsername: z.string().trim().min(1).max(64), reason, requestId });
//# sourceMappingURL=admin-tools.js.map